import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import pro1 from'../assets/pro0.jpg';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import mu5 from '../assets/mu5.png';
import svg from '../assets/svg.jpeg'
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';
import logo1 from '../assets/logo1.png';
import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';

import adidas from '../assets/adidas.png';
import amazon from '../assets/amazon.png';
import asus from '../assets/asus.png';
import bolt from '../assets/bolt.png';
import nb from '../assets/nb.png';
import skype from '../assets/skype.png';
import spotify from '../assets/spotify.png';

import t2 from '../assets/t2.jpg';
import t1 from '../assets/t1.png'
import ch from '../assets/ch.png'
import trial from '../assets/trial.png';
import afra from '../assets/afrah.png';
import tab from '../assets/tab.png';
import sql from '../assets/sql.jpeg';
import py from '../assets/py.jpeg'
import sequel from '../assets/sql.png'
import r from '../assets/r.png'
import f from '../assets/chr.png'
import tu from '../assets/tu.png'
import tuu from '../assets/tu.v1.png'
import yu from '../assets/yu.png'
import back from '../assets/back0.png'
import wp from '../assets/wp.png'
import wp1 from '../assets/wp1.png'


export default {
    tab,py,sql,
    back,
    tuu,
    yu,
    tu,
    f,
    r,
    sequel,
    logo1,
    ch,
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
  pro1,svg,t2,t1,trial,afra,
  wp,wp1  
};